import { find } from 'lodash';

class PropertiesSelectController {

    constructor(propertiesService, messageService) {
        this.propertiesService = propertiesService;
        this.messageService = messageService;
    }

    $onInit () {
        this.ngModel.$render = () => {
            if (this.properties && this.ngModel.$viewValue) {
                this.value = this.ngModel.$viewValue.map(slug => find(this.properties, { slug }));
            }
        };

        this.propertiesService.findAll(-1)
            .then(properties => this.properties = properties)
            .then(() => this.ngModel.$render())
            .catch(errors => {
                this.messageService.failure(errors);
                this.messageService.push();
            });
    }

    updateViewValue (isOpen = false) {
        if (!isOpen) {
            this.setValue();
            this.ngModel.$setTouched();
        }
    }

    setValue () {
        this.ngModel.$setViewValue(this.value.map(property => property.slug));
    }
}

PropertiesSelectController.$inject = ['propertiesService', 'messageService'];

export default PropertiesSelectController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/properties.select.controller.js